import { graphql } from "gatsby";
import React, { FC } from "react";

import { Tag, TagProps } from "../tag";

export interface WhatsNextCategoryProps extends Queries.WhatsNextCategoryDataFragment, TagProps {}

export const WhatsNextCategory: FC<WhatsNextCategoryProps> = ({ label, ...props }) => {
  return <Tag {...props}>{label}</Tag>;
};

export const query = graphql`
  fragment WhatsNextCategoryData on ContentfulWhatsNextCategory {
    label
  }
`;
